exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_avatarContainer__g7FH3{display:inline-flex;align-items:center;justify-content:center;border-radius:50%}", ""]);

// exports
exports.locals = {
	"avatarContainer": "style_avatarContainer__g7FH3"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/Avatar/style.less
// module id = 1643
// module chunks = 8